import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Login.css';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const nav = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      const user = await login(form);
      const requestedPath = location.state?.from?.pathname;
      const rolePath = user.role === 'admin' ? '/dashboard/admin' : '/dashboard/member';
      nav(requestedPath || rolePath, { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div>
            <p className="login-eyebrow">SFACO-CTG</p>
            <h1>Member/Admin login</h1>
            <p className="login-subtitle">
              Sign in with email/password. Approved members and admins can access their dashboards.
            </p>
          </div>
        </div>

        <form className="login-form" onSubmit={submit}>
          <label>
            Email address
            <input
              type="email"
              placeholder="you@alumni.org"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </label>
          <label>
            Password
            <div className="login-password-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
              />
              <button
                type="button"
                className="login-password-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </label>

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="login-submit">Sign in</button>

          <p className="login-footnote">
            Forgot password? <Link to="/forgot-password">Reset it</Link>
          </p>
          <p className="login-footnote">
            New here? <Link to="/register">Create an account</Link>
          </p>
          <Link className="back-home" to="/">Back to home</Link>
        </form>
      </div>
    </div>
  );
}
